import React, { useEffect } from 'react'
import {
  ArrowDropDown,
  ArrowDropUp,
  withStyles,
  WithStyles,
  List,
  ListItem,
  Collapse,
} from '@zn-material-ui'
import Store from 'store'
import styles from './styles/index'
import classnames from 'classnames'
import result from './code'

interface IDataItem {
  country: string
  chName: string
  countryCode: string
  code: string
}
interface IProps extends WithStyles<typeof styles> {
  onChange: (value: string) => void
  containerStyle?: any
  labelClass?: any
  collapseClass?: any
  lineHeight?: number
  code?: string
}
const Select = (props: IProps) => {
  const areaCode = Store.get('areaCode') || '86'
  const { classes, onChange } = props
  const [checked, setChecked] = React.useState(false)
  const [code, setValue] = React.useState(areaCode)
  const data = result.data
  useEffect(() => {
    if (props.code) {
      setValue(props.code)
    }
  }, [props.code])
  return (
    <React.Fragment>
      <div
        className={(checked && classes.optionMask) || ''}
        onClick={() => setChecked(false)}
      />
      <div className={classes.selectContainer} style={props.containerStyle}>
        <div
          className={classnames(classes.select, props.labelClass)}
          onClick={() => setChecked(!checked)}
        >
          <div className="selected">
            <p>{`+${code}`}</p>
            {checked ? (
              <ArrowDropUp className="arrowIcon" />
            ) : (
              <ArrowDropDown className="arrowIcon" />
            )}
          </div>
        </div>
        {data.length > 1 && (
          <Collapse
            timeout={100}
            in={checked}
            className={classnames(
              classes.option,
              (!checked && classes.hideBorder) || '',
              props.collapseClass
            )}
          >
            <List className={classes.itemHeight}>
              {data.map((item: IDataItem, i) => (
                <ListItem
                  classes={{ gutters: 'listItem', selected: 'selected' }}
                  selected={item.code === code}
                  onClick={() => {
                    setValue(item.code)
                    setChecked(false)
                    onChange(item.code)
                  }}
                  key={item.countryCode}
                >
                  <p className={classes.menuItemName}>{item.chName}</p>
                  <p className="code">{`+${item.code}`}</p>
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </div>
    </React.Fragment>
  )
}

export default withStyles(styles)(Select)
